
export enum FlexSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  Wide = 'Wide',
  Tall = 'Tall',
  AutoWidth = 'AutoWidth'
}
